import V3Check from './V3Check'
import { CheckUtils } from 'utils'

export default class V3FilenamesCheck extends React.Component {
  constructor(props) {
    super(props)

    this.renderInfo = this.renderInfo.bind(this)
    this.renderDetails = this.renderDetails.bind(this)
  }

  render() {
    const props = {
      ...this.props,
      info: this.renderInfo,
      details: this.renderDetails
    }

    return <V3Check { ...props } />
  }

  renderDetails() {
    return CheckUtils.renderDetailsList(this.props.check.checkItems)
  }

  renderInfo() {
    return (
      <div>
        <div>
          <h2>Key points</h2>
          <p>
            Create files with names that describe their contents.
          </p>
          <hr />
          <h2>How it's used</h2>
          <ul>
            <li>Used in search engine algorithms</li>
            <li>Especially important for files which don't contain plain text, like photos</li>
            <li>A good habit is to name all files descriptively even though some file types won't benefit</li>
          </ul>
          <hr />
          <h2>Best practice</h2>
          <ul>
            <li>Separate words with dashes (underscores are okay too)</li>
            <li>Not too many words, four or five is good</li>
            <li>Something like this is good: mens-red-parka-winter-jacket.jpg</li>
          </ul>
          <hr />
        </div>
        <div>
          <h2>Fix this yourself</h2>
          <h3>Image uploads</h3>
          When you upload an image to Shopify it preserves the file name. So name the file well while it's on your disk, then upload it.
          <br /><br />
          To fix poorly named images that are already on Shopify:
          <ol>
            <li>Download the image</li>
            <li>Rename it descriptively</li>
            <li>Delete it from Shopify</li>
            <li>Upload the image again</li>
          </ol>

          <h3>Page URLs</h3>
          Shopify adapts the names you give to products, blog post titles etc. into the URL. Give these things good names for your URLs to be great.
        </div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./app/components/v3_checks/V3FilenamesCheck.js